function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{fill:none;}.c{clip-path:url(#a);}.d{fill:#accad2;}.e{fill:#d8ae30;}.f,.h{fill:#ecd8dd;}.g{fill:#cf5285;}.h{opacity:0.4;}.i{fill:#252658;}.j{fill:#627f84;}.k{opacity:0.3;}.l{fill:#b3c0c1;}.m{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 375,
  height: 251,
  transform: "translate(0 561)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M221.344,306.043c14.7,5.335,25.6,18.469,28.8,35.2s-3.8,36.055-28.8,44.893-21,12.021-24,33.18-23.193,47.939-64.1,32.048-48.9-37.062-43.4-57.476,17.807-35.235,43.4-41.574,36.608-13.28,41.6-24.06S189.844,294.613,221.344,306.043Z",
  transform: "translate(-88.299 -302.923)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "translate(0 -561)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-244 -6.432)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M173.462,224.631s20.078-4.5,32.636-21,22.1-34.169,9.829-39.085-32.974,30.043-32.974,30.043,6.463-30.015-2.667-52.487-26.131-29.119-32.131-13.545,5.5,62.074,5.5,62.074-22.263-30-35.381-21.5,4.381,33,18.381,41.5S160.27,225.131,173.462,224.631Z",
  transform: "translate(394.732 493)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(388.917 612.038)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M332.355,173.142a52.5,52.5,0,0,0-22.839-41.607c-13.685-9.067-30.1-8.678-45.144-3.622a83.463,83.463,0,0,0-16.085,7.654c-1.564.935-3.088,1.936-4.584,2.975-.331.229-2.228,1.656-1.31.934-2.6,2.048-10.7-1.44-8.038-3.532C255.206,119.536,285,113.265,309.329,125.3c17.947,8.879,31.4,28.453,31.753,48.8.069,3.927-8.671,2.215-8.727-.961Z",
  transform: "translate(-233.827 -119.038)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.026 14.142)"
}, /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M316.328,170.336a34.671,34.671,0,0,0-14.5-27.158c-8.861-6.113-19.53-5.557-29.3-2.261a54.53,54.53,0,0,0-10.041,4.8c-1.026.6-2.022,1.254-3.007,1.921-.272.184-2.182,1.615-1.061.736-2.607,2.044-10.7-1.447-8.038-3.531,14.328-11.232,34.214-15.357,51.136-7.887,13.147,5.8,23.248,19.738,23.538,34.341.077,3.925-8.665,2.217-8.728-.961Z",
  transform: "translate(-249.852 -133.181)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.334 28.16)"
}, /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M302.021,168.411a18.631,18.631,0,0,0-5.8-12.855c-6.324-6.021-16.521-2.278-22.52,2.374-2.466,1.913-10.417-1.687-6.852-4.451a29.88,29.88,0,0,1,30.452-3.688c7.408,3.4,13.24,11.276,13.448,19.581.1,3.92-8.647,2.222-8.727-.961Z",
  transform: "translate(-265.943 -147.198)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(598.117 676.172)"
}, /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M125.634,248.131c-5.379-5.545-12-6-12-13.334s12.333-6.333,13.666-16-4.333-17-12-15.333-16.3.667-19.985-6.333-10.681-15.667-21.348-13.667S63.615,197.8,57.457,197.131s-18.49-8.667-26.157-2S37,218.8,32.815,224.8,9.633,239.465,11.3,252.8s13.333,23,27,23.333,17.537,6.667,24.435,16S86,305.465,95.315,301.8s6.986-18.668,15.652-23.334,19.765-5.628,20.765-14.961S128.542,251.129,125.634,248.131Z",
  transform: "translate(-11.197 -183.172)"
}), /*#__PURE__*/React.createElement("path", {
  className: "h",
  d: "M20.8,251.32c3.875,4.547,7.851,9.017,11.982,13.332,1.337,1.4,2.71,2.759,4.143,4.058.416.378,2.748,2.609,2.52,1.012-.4-2.8-2.276-5.717-3.5-8.21-3.034-6.179-7.23-12.459-9.057-19.139-.717-2.62,2.166-.13,2.749.451,9.513,9.48,15.96,22.058,25.94,31.045.521.469-1.021-3.135-1.324-3.749-1.622-3.287-3.419-6.492-5.175-9.709-3.857-7.065-7.879-14.1-11.086-21.5-.19-.437-2.993-6.963-.8-6.215,2.453.837,4.437,5.389,5.689,7.361,8.132,12.8,15.355,26.168,23.4,39.031,2.491,3.983,5.083,9.152,8.837,12.135,1.024.814-.044-2.813-.133-3.071-.811-2.351-1.871-4.624-2.909-6.88-6.394-13.888-13.826-27.311-20.9-40.861-2.739-5.25-5.524-10.5-7.989-15.883-.155-.34-2.216-4.3-.782-3.9,1.738.485,3.328,4.54,4.128,5.888,3.1,5.231,6.034,10.559,8.988,15.872C63.3,256.364,70.9,270.438,79.064,284.186c2.382,4.014,4.727,8.248,7.742,11.835.875,1.042,1.051.935.7-.3a32.865,32.865,0,0,0-1.805-4.437C73.83,265.188,58.561,240.7,46.14,214.855a78.409,78.409,0,0,1-5.15-12.244c-.2-.714-.763-3.072.8-2.438,2.053.831,3.521,3.823,4.653,5.539,3.036,4.6,5.763,9.417,8.488,14.208,7.769,13.659,15.152,27.536,22.7,41.32,5.436,9.933,10.469,20.845,17.481,29.8,2.416,3.086.209-2.595-.232-3.638-2.13-5.041-4.735-9.9-7.276-14.739C80.2,258.565,72.4,244.682,64.8,230.69c-5.237-9.643-11.947-19.768-15.119-30.361-.259-.863-.422-2.569,1-1.737,2.4,1.4,4.1,4.677,5.6,6.89,15.839,23.291,28.282,48.742,43.95,72.137a39.586,39.586,0,0,0,2.7,3.686c1.05,1.234.492-.117.2-1-1.455-4.352-3.832-8.492-5.918-12.559-7.118-13.879-14.695-27.521-21.994-41.3-3.059-5.778-6.107-11.571-8.909-17.479-.713-1.5-3.635-6.034-2.8-7.838.524-1.13,2.734,1.668,2.877,1.847a122.149,122.149,0,0,1,8.469,12.988c8.1,13.329,15.752,26.923,23.792,40.287,2.895,4.811,5.785,9.675,9.1,14.214.208.285,2.263,2.868,2.4,2.453.367-1.116-.632-3.046-1-4.048-9.592-25.792-26.462-48.459-36.43-74.084-.211-.543-1.606-3.625.072-3.072,1.937.639,3.606,4.879,4.513,6.43,7.115,12.164,13.519,24.749,20.347,37.074,3.774,6.812,7.617,13.594,11.747,20.2,2.511,4.016,5.134,8.632,8.794,11.738,3.821,3.244.908-6.005.515-7a156.558,156.558,0,0,0-8.563-17.2c-7.552-13.79-15.783-27.193-23.521-40.877-2.349-4.153-4.905-8.37-6.577-12.856-.341-.915-.793-3.056.944-2.131,3.195,1.7,5.441,6.362,7.321,9.245,4.172,6.4,8.02,13.012,11.872,19.6,3.625,6.205,7.184,12.449,10.865,18.622,1.059,1.773,2.124,3.548,3.286,5.257,1.325,1.95.4.223-.109-1.139-4.727-12.7-11.967-24.519-17.659-36.8-.078-.166-2.392-5.105-.65-3.773,3.673,2.811,6.282,8.607,8.859,12.352,3.384,4.917,6.832,11.154,11.633,14.851,1.707,1.314.842-3.3.7-3.865a44.508,44.508,0,0,0-2.019-5.543c-1-2.464-3.231-5.939-3.092-8.695.16-3.151,5.417,3.152,5.693,3.463,1.209,1.365,2.4,2.744,3.637,4.086,1.1,1.2,5.164,5.115,4.778.827-.288-3.2-2.81-6.493-4.708-8.96-.177-.23.541-.147.666.015.995,1.292,7.784,11.935,3.538,11.843-3.953-.086-8.4-7.74-10.778-10.236-3.847-4.043-.431,4.342.191,5.844,1.346,3.248,3.181,6.768,3.277,10.35.1,3.733-4.094-.554-4.745-1.276-4.945-5.488-8.914-11.956-13.077-18.035-1.449-2.116-2.871-4.272-4.476-6.274-.04-.05-.066-.085-.1-.126a2.386,2.386,0,0,1,.122.292,31.917,31.917,0,0,0,1.27,2.967c5.767,12.617,13.8,24.79,18.085,38.016.6,1.861-.565,1.347-1.341.317-2.894-3.842-5.142-8.274-7.557-12.421-7.343-12.607-14.172-25.926-22.99-37.591-.294-.389-2.95-3.61-3.11-2.716-.212,1.181.845,2.9,1.3,3.909,2.353,5.164,5.3,10.082,8.124,15,7.893,13.736,16.156,27.269,23.6,41.26.708,1.33,10.863,20.375,6.525,20.473-2.185.05-4.053-2.678-5.226-4.141A128.122,128.122,0,0,1,104.839,249c-7.822-13.207-14.948-26.818-22.3-40.29-2.639-4.838-5.233-9.737-8.216-14.376a13.007,13.007,0,0,0-1.63-2.165c-.224,1.15.809,2.926,1.222,3.932,5.32,12.951,12.427,25.287,18.841,37.711,6.1,11.822,13.195,23.774,17.547,36.4.177.515,1.4,3.918-.361,3.21-2.292-.921-4.007-4.549-5.269-6.452-8.112-12.232-15.215-25.164-22.638-37.818-3.625-6.179-7.262-12.356-11.067-18.426-.447-.714-6.834-9.187-6.773-9.319-.91,1.963,2.861,7.743,3.646,9.368,2.976,6.164,6.2,12.212,9.409,18.256,7.23,13.611,14.717,27.091,21.7,40.829,1.838,3.617,4.029,7.375,5.127,11.308.355,1.272-.462,1.429-1.316.652-2.5-2.273-4.254-5.772-6.036-8.587-3.613-5.707-7.063-11.52-10.518-17.326-8.1-13.6-16.033-27.309-24.378-40.765-2.839-4.578-5.691-9.188-8.931-13.5-.156-.209-2.5-3.083-2.678-2.776-.424.725.452,2.453.7,3.116,4.285,11.484,11.05,22.326,16.9,33.049,7.488,13.733,15.153,27.376,22.34,41.27a125.544,125.544,0,0,1,6.2,13.114c.167.443,1.464,3.606-.106,3.168-1.806-.5-3.148-3.361-4.064-4.765-2.882-4.415-5.464-9.036-8.054-13.627-7.675-13.605-15.006-27.4-22.526-41.093-5.693-10.364-11.04-21.573-18.334-30.94-2.721-3.494-1.592.7-.882,2.664a141.651,141.651,0,0,0,6.458,14.239c6.971,14.125,14.5,27.976,21.9,41.879,5.743,10.793,11.993,21.55,16.714,32.847,2.878,6.887-2.491.816-4.109-1.613-7.767-11.664-14.316-24.219-21.108-36.46C56.069,244.57,50.333,232.93,43.275,222.3c-.578-.87-.959-1.992-.553-.594a32.573,32.573,0,0,0,2.063,4.8c2.774,5.834,5.82,11.543,8.815,17.267,6.93,13.242,14.227,26.383,20.3,40.05.543,1.221,3.575,6.534,2.3,7.891-1.041,1.106-3.707-2.549-4.03-2.954-8.862-11.134-15.437-24.428-22.651-36.642-3.2-5.423-6.364-10.907-9.949-16.089-.239-.345-2.4-3.108-2.489-2.8-.575,2.056,1.473,5.459,2.261,7.224,1.352,3.026,18.7,32.964,17.184,34.018-2.3,1.591-18.061-20.429-19.713-22.475-2.051-2.539-4.121-5.066-6.286-7.51-1.066-1.2-3.795-4.663-2.657-1.137,2.233,6.921,6.432,13.392,9.6,19.914.249.513,4.325,8.434,1.752,7.526-4.792-1.691-9.186-8.3-12.428-11.891q-3.379-3.744-6.655-7.587C19.954,251.089,20.671,251.164,20.8,251.32Z",
  transform: "translate(-15.201 -183.172)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(35.973 34.709)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M75.027,217.881c10.152,0,17.5,5.75,20.5,16.75s-12,33-32,30-23.75-20-21-30.75S53.777,217.881,75.027,217.881Z",
  transform: "translate(-41.73 -217.881)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.79 4.153)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M56.737,224.881a2.464,2.464,0,0,1,2.483,2.029c.363,1.331-1.454,3.995-3.875,3.632a2.916,2.916,0,0,1-2.543-3.723C53.135,225.517,54.164,224.881,56.737,224.881Z",
  transform: "translate(-17.853 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M53.233,235.406a2.464,2.464,0,0,1-.239,3.2c-.882,1.061-4.106,1.1-5.2-1.092a2.917,2.917,0,0,1,1.593-4.218C50.647,232.819,51.758,233.3,53.233,235.406Z",
  transform: "translate(-7.002 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M65.091,234.43a2.463,2.463,0,0,1-.239,3.2c-.882,1.061-4.106,1.1-5.2-1.093a2.917,2.917,0,0,1,1.593-4.218C62.505,231.843,63.616,232.321,65.091,234.43Z",
  transform: "translate(-30.72 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M60.018,240.979a2.462,2.462,0,0,1,2.482,2.028c.364,1.331-1.453,3.995-3.875,3.632a2.917,2.917,0,0,1-2.542-3.723C56.416,241.614,57.445,240.979,60.018,240.979Z",
  transform: "translate(-24.413 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M65.356,222.034a2.462,2.462,0,0,1,2.482,2.029c.364,1.331-1.453,3.995-3.875,3.632a2.916,2.916,0,0,1-2.542-3.723C61.754,222.67,62.783,222.034,65.356,222.034Z",
  transform: "translate(-35.089 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M54.282,247.43a2.462,2.462,0,0,1-.238,3.2c-.882,1.061-4.107,1.1-5.2-1.093a2.917,2.917,0,0,1,1.593-4.218C51.7,244.843,52.807,245.321,54.282,247.43Z",
  transform: "translate(-9.102 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M61.851,251.313a2.462,2.462,0,0,1,2.483,2.027c.363,1.332-1.453,4-3.875,3.633a2.917,2.917,0,0,1-2.543-3.723C58.249,251.947,59.278,251.313,61.851,251.313Z",
  transform: "translate(-28.081 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M75.571,222.8a2.462,2.462,0,0,1,2.483,2.027c.363,1.332-1.454,4-3.875,3.633a2.916,2.916,0,0,1-2.543-3.723C71.969,223.433,73,222.8,75.571,222.8Z",
  transform: "translate(-55.521 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M74.212,234.43a2.464,2.464,0,0,1-.239,3.2c-.882,1.061-4.106,1.1-5.2-1.092a2.917,2.917,0,0,1,1.593-4.218C71.626,231.843,72.737,232.322,74.212,234.43Z",
  transform: "translate(-48.96 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M72.712,247.43a2.464,2.464,0,0,1-.239,3.2c-.882,1.061-4.106,1.1-5.2-1.093a2.917,2.917,0,0,1,1.593-4.218C70.126,244.843,71.237,245.321,72.712,247.43Z",
  transform: "translate(-45.96 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M72.291,255.131a2.462,2.462,0,0,1,2.483,2.027c.363,1.332-1.453,4-3.875,3.633a2.917,2.917,0,0,1-2.543-3.723C68.689,255.766,69.718,255.131,72.291,255.131Z",
  transform: "translate(-48.96 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M82.133,252.283a2.461,2.461,0,0,1,2.482,2.027c.363,1.333-1.453,4-3.875,3.633a2.916,2.916,0,0,1-2.543-3.722C78.531,252.918,79.559,252.283,82.133,252.283Z",
  transform: "translate(-68.642 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M80.773,244.337a2.465,2.465,0,0,1-.239,3.2c-.882,1.061-4.106,1.1-5.2-1.094a2.916,2.916,0,0,1,1.593-4.217C78.187,241.75,79.3,242.229,80.773,244.337Z",
  transform: "translate(-62.082 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M82.606,235.406a2.465,2.465,0,0,1-.239,3.2c-.882,1.061-4.106,1.1-5.2-1.094a2.917,2.917,0,0,1,1.593-4.218C80.02,232.819,81.131,233.3,82.606,235.406Z",
  transform: "translate(-65.748 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M90.485,245.861a2.465,2.465,0,0,1-.238,3.2c-.883,1.06-4.107,1.1-5.2-1.094a2.917,2.917,0,0,1,1.593-4.218C87.9,243.274,89.01,243.753,90.485,245.861Z",
  transform: "translate(-81.508 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M86.3,225.645a2.461,2.461,0,0,1,2.482,2.027c.364,1.332-1.453,4-3.875,3.633a2.916,2.916,0,0,1-2.542-3.722C82.7,226.28,83.726,225.645,86.3,225.645Z",
  transform: "translate(-76.975 -222.034)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M93.639,235.406a2.465,2.465,0,0,1-.239,3.2c-.883,1.061-4.107,1.1-5.2-1.094a2.917,2.917,0,0,1,1.593-4.218C91.053,232.819,92.164,233.3,93.639,235.406Z",
  transform: "translate(-87.814 -222.034)"
})))), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M218.112,245.148c14.486-7.588,32.333-6.324,59.667,12.83s39,54.486,16,68.153-69-5.332-84.667-27.666S203.446,252.832,218.112,245.148Z",
  transform: "translate(222.775 493)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(501.861 723.187)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M222.026,230.276c3.239.922,5.092,2.24,5.862,4.34.555,1.515.118,3.687-.615,7.234-.767,3.708-2.551,5.961-4.881,6.657-2.989.893-6.526-.49-7.509-3.3a14.445,14.445,0,0,1,.356-8.995C216.582,232.74,219.7,229.615,222.026,230.276Z",
  transform: "translate(-214.327 -230.187)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.429 1.127)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M196.062,231.446c2.553.048,4.7.5,6.209,2,1.745,1.738,2.994,4.166,2.189,6.406-.761,2.116-4.73,1.645-8.309.97-3.476-.656-7.194-1.552-7.563-3.646a5.089,5.089,0,0,1,1.874-5.3C191.722,231,193.688,231.4,196.062,231.446Z",
  transform: "translate(-188.477 -231.314)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.955 23.113)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M202.828,253.311c2.3.1,4.073,1.516,5.539,3.057,1.4,1.471,2.346,3.006,1.491,5.693-.87,2.737-3.81,3.761-6.981,3.712-3.2-.049-6.184-1.213-7.063-3.725-.906-2.586-.737-4.845.688-6.446A7.821,7.821,0,0,1,202.828,253.311Z",
  transform: "translate(-195.254 -253.3)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(39.49 33.679)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M181.366,264.138c2.234-.894,4.464.551,5.908,2.34a5.044,5.044,0,0,1,.67,5.995,5.422,5.422,0,0,1-4.744,2.8c-2.1.1-4.269-.458-4.931-2.577C177.019,268.691,177.616,265.638,181.366,264.138Z",
  transform: "translate(-177.677 -263.866)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(53.264 13.223)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M168.287,243.87a4.568,4.568,0,0,1,6.539,4.809,16.266,16.266,0,0,1-2.052,5.006c-.809,1.5-1.915,3.1-4.44,2.212-2.508-.877-3.648-3.661-3.579-5.948S166.044,244.867,168.287,243.87Z",
  transform: "translate(-164.752 -243.41)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(65.032 35.666)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M155.886,265.853a10.452,10.452,0,0,1,5.792,1.516c1.622,1.205,1.651,3.257,1.124,5.366a6.394,6.394,0,0,1-4.373,4.823,6.53,6.53,0,0,1-6.345-2.029c-1.9-1.948-2.356-4.131-1.594-6.084A5.437,5.437,0,0,1,155.886,265.853Z",
  transform: "translate(-150.139 -265.853)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(54.868 57.982)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M166.948,288.78a14.228,14.228,0,0,1,4.445,3.326c1.555,1.552,2.412,3.1,1.511,5-.765,1.612-4.861,2.457-8.427,1.837-3.426-.6-6.922-2.64-7.411-4.477-.538-2.014,1.162-4.381,3.371-5.5A7.932,7.932,0,0,1,166.948,288.78Z",
  transform: "translate(-156.965 -288.169)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(31.781 60.116)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M191.491,290.709c2.1-1.136,3.951.273,4.62,2.253a8.167,8.167,0,0,1-.638,5.466c-.79,1.761-5.118,1.044-6.907-1.159C187.215,295.6,187.51,292.861,191.491,290.709Z",
  transform: "translate(-187.839 -290.303)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(52.011 73.041)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M172.942,304.3c1.823,1.66,4.584,6.43,2.354,7.68-1.12.629-3.624-.387-5.6-1.4-1.949-1-3.661-2.369-2.915-4.233C168.285,302.6,171.13,302.65,172.942,304.3Z",
  transform: "translate(-166.606 -303.228)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.517 44.054)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M213.665,274.815c3.655-1.625,6.4.369,5.9,3.865a16.364,16.364,0,0,1-1.574,5.17c-.809,1.5-1.875,2.162-4.4,1.278-2.507-.878-4.306-2.868-4.237-5.157S211.421,275.811,213.665,274.815Z",
  transform: "translate(-209.349 -274.241)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.645 79.416)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M196.565,310.565c1.823,1.661,4.269,6.486,2.04,7.736-1.12.629-3.777.286-5.749-.727-1.949-1-3.175-2.77-2.429-4.634C191.927,309.19,194.753,308.916,196.565,310.565Z",
  transform: "translate(-190.206 -309.603)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(351.066 608.351)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(98.638 81.87)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M267.741,197.246c10.3,1.184,13.585,9.274,12.285,18.941-1.032,7.677-14.363,7.732-19.744,7.225-6.117-.577-16.384-3.8-15.494-11.8,1.109-9.955,14.285-14.79,22.953-14.367,1.506.073,2.347,1.867.352,1.77-7.3-.355-16.474,3.586-19.732,10.446-3.745,7.887,5.653,11.437,11.57,12.18,5.216.653,12.516.213,16.209-4.072,2.183-2.533,1.282-7.348.841-10.319-.741-4.986-3.961-7.668-8.888-8.235C266.618,198.847,265.743,197.016,267.741,197.246Z",
  transform: "translate(-244.734 -197.22)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(85.354 61.274)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M284.86,176.627a8.793,8.793,0,0,1,8.665,8.115c.525,4.722-2.784,7.985-7.361,8.028-3.712.035-8.979-1.649-10.068-5.714-1.374-5.124,3.449-10.083,8.391-10.424,1.4-.1,2.972,1.951,1.009,2.086a7.52,7.52,0,0,0-6.725,7.271c.027,3.293,3.881,4.562,6.55,4.689,7.37.351,6.733-11.714-.2-11.954C283.486,178.667,282.885,176.558,284.86,176.627Z",
  transform: "translate(-275.858 -176.625)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.55 82.817)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M316.711,198.558c3.7.929,13.386,5.6,9.945,11.034-2.445,3.862-9.737,3.022-13.513,2.4-4.409-.724-9.629-2.749-9.567-7.893.072-6.085,8.507-6.413,12.743-5.62,1.374.257,2.38,2.007.388,1.634-3.476-.651-8.125-.566-9.87,3.1-1.98,4.156,2.284,6.3,5.539,7.072a17.649,17.649,0,0,0,10-.378c1.6-.63,2.01-2.216,1.737-3.808-.589-3.443-4.9-5.332-7.794-6.059C314.561,199.6,314.967,198.12,316.711,198.558Z",
  transform: "translate(-303.576 -198.168)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.52 57.533)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M319.408,173c4.032.9,7.816,3.448,8,7.915.184,4.444-4.4,6.026-8.052,5.834-3.064-.162-8.688-1.848-8.895-5.672-.235-4.354,4.224-8.61,8.555-8.159,1.289.133,2.5,1.519.475,1.308-2.7-.281-5.4,3.747-6.018,5.852-1.07,3.684,2.992,5.463,5.991,5.3a5.167,5.167,0,0,0,5.032-4.807c.352-3.311-2.44-5.769-5.4-6.43C317.362,173.753,317.694,172.616,319.408,173Z",
  transform: "translate(-310.453 -172.884)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(69.098 103.921)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M303.338,219.3c4.216.6,6.531,5.352,6.5,9.258-.038,4.592-5.581,6.788-9.5,6.722-4.462-.074-8.253-2.934-7.883-7.669.409-5.228,6.211-8.37,10.887-8.311,1.607.02,2.265,2.025.29,2a8.69,8.69,0,0,0-7.844,5.393,4.494,4.494,0,0,0,4.474,6.562c2.548-.116,5.755-1.527,6.519-4.138.567-1.936-.633-7.458-3.149-7.817C302.081,221.077,301.361,219.016,303.338,219.3Z",
  transform: "translate(-292.426 -219.272)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.074 107.863)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M334.7,223.423c3.255-.551,8.557-.3,8.135,4.318-.42,4.58-4.492,7.1-8.534,8.411-2.724.885-7.8,1.242-8.548-2.517-1.017-5.123,4.172-9.13,8.613-10.137,1.226-.278,3.434,1.535,1.678,1.933a9.694,9.694,0,0,0-7.249,5.87c-1.413,3.834,1.88,3.551,4.382,2.739a11.712,11.712,0,0,0,5.95-4.126,5.487,5.487,0,0,0,.722-3.691c-.218-1.643-3.124-.89-4.139-.718C334.3,225.745,332.759,223.752,334.7,223.423Z",
  transform: "translate(-325.625 -223.214)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.555 71.353)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M346.56,186.9c4.219,1.281,8.057,5.477,6.442,10.13-1.531,4.412-7.97,5.357-11.791,4.12-4.2-1.361-5.566-5.207-4.069-9.154a8.005,8.005,0,0,1,9.418-5.1c1.808.382,1.3,2.165-.479,1.79-5.023-1.063-9.49,7.924-4.582,10.564,2.821,1.517,7.266-.2,8.6-3,1.453-3.037-1.139-6.688-4.023-7.563C344.336,188.164,344.8,186.368,346.56,186.9Z",
  transform: "translate(-336.554 -186.704)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 56.205)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M369.23,171.6c4.628.621,10.33,1.933,9.648,7.748-.573,4.9-5.583,12.1-11.281,10.59-9.67-2.563-9.527-19.288,1.633-18.338,1.477.126,2.36,1.909.359,1.739-7.1-.6-7.415,9.625-3.944,13.555,4.254,4.815,8.823-3.566,9.92-6.689,1.748-4.98-1.781-6.3-5.976-6.866C368.138,173.139,367.232,171.327,369.23,171.6Z",
  transform: "translate(-360.588 -171.556)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.819 33.063)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M341.322,148.417c5.406.3,13.211,2.455,14.629,8.492,1.659,7.053-9.671,10.779-14.8,10.347-5.377-.453-10.254-2.779-10.684-8.7-.458-6.316,5.154-10.122,10.858-10.141.553,0,3.282,1.089,1.9,1.094-7.5.025-13.743,9.361-7.416,15.322,4.571,4.305,14.045-.6,16.676-5.065,3.4-5.776-4.706-10-9.26-10.257C342.681,149.48,339.968,148.342,341.322,148.417Z",
  transform: "translate(-330.438 -148.413)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(129.081)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.102 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M216.032,115.353a8.793,8.793,0,0,1,8.665,8.115c.524,4.723-2.784,7.986-7.362,8.029-3.712.034-8.978-1.649-10.068-5.714-1.373-5.124,3.449-10.084,8.392-10.424,1.4-.1,2.972,1.951,1.009,2.086a7.519,7.519,0,0,0-6.725,7.27c.027,3.294,3.88,4.562,6.549,4.689,7.371.351,6.733-11.714-.2-11.953C214.658,117.394,214.056,115.285,216.032,115.353Z",
  transform: "translate(-207.029 -115.351)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(27.114 24.372)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M215.921,139.922c4.219,1.281,8.056,5.477,6.441,10.13-1.531,4.413-7.969,5.357-11.791,4.12-4.2-1.36-5.565-5.207-4.069-9.153a8.008,8.008,0,0,1,9.419-5.1c1.807.383,1.295,2.166-.48,1.79-5.022-1.062-9.49,7.924-4.581,10.565,2.821,1.517,7.265-.2,8.6-3,1.453-3.037-1.139-6.689-4.023-7.564C213.7,141.183,214.157,139.387,215.921,139.922Z",
  transform: "translate(-205.915 -139.723)"
})), /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M244.409,115.373c3.531.5,5.471,4.484,5.444,7.757-.032,3.847-4.676,5.687-7.961,5.631-3.738-.062-6.914-2.458-6.6-6.425.342-4.379,5.2-7.012,9.121-6.963,1.346.018,1.9,1.7.243,1.676a7.282,7.282,0,0,0-6.572,4.518,3.766,3.766,0,0,0,3.749,5.5c2.135-.1,4.821-1.28,5.461-3.467.475-1.622-.53-6.248-2.638-6.549C243.356,116.864,242.752,115.137,244.409,115.373Z",
  transform: "translate(-235.267 -115.351)"
}))), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M445.37,192.771c9.485,5.675,38.05,39,34.858,52.182s-21.525-7.4-32.858-13.113-26-.729-27.333,11.615,14.333,53.009-15,56.676-40.334-21.69-43.667-39.345,1.334-47.444,15.334-62.05S421.37,178.411,445.37,192.771Z",
  transform: "translate(-110.816 493)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(296.614 751.622)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M399.713,260.786c19.378,7.985,41.765,21.038,30.765,42.442s-19.5,14.4-27,46.4-50.591,30-70.795,6.5-15.7-37.359,5.8-48.43,31.857-33.689,35.678-38.13S383.1,253.941,399.713,260.786Z",
  transform: "translate(-319.705 -258.622)"
}), /*#__PURE__*/React.createElement("g", {
  className: "k",
  transform: "translate(6.74 5.877)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M328.132,267.693s42.5,28.75,41.5,31.25S321.132,265.693,328.132,267.693Z",
  transform: "translate(-270.433 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M327.445,264.565s34.527,23.356,33.714,25.386S321.759,262.94,327.445,264.565Z",
  transform: "translate(-261.402 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M335.861,274.406s42.5,28.75,41.5,31.25S328.861,272.406,335.861,274.406Z",
  transform: "translate(-285.89 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M340.766,283.95s42.5,28.75,41.5,31.25S333.766,281.95,340.766,283.95Z",
  transform: "translate(-295.701 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M347.268,293.748s42.5,28.75,41.5,31.25S340.268,291.748,347.268,293.748Z",
  transform: "translate(-308.705 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M353.768,302.792s42.5,28.75,41.5,31.25S346.768,300.792,353.768,302.792Z",
  transform: "translate(-321.705 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M353.882,309.487s49.378,32.5,48.216,35.322S345.749,307.227,353.882,309.487Z",
  transform: "translate(-328.538 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M360.132,316.481s49.378,32.5,48.216,35.322S352,314.221,360.132,316.481Z",
  transform: "translate(-341.038 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M368.494,325.215s49.377,32.5,48.215,35.321S360.361,322.954,368.494,325.215Z",
  transform: "translate(-357.759 -264.499)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M378.409,332.389s49.378,32.5,48.216,35.321S370.276,330.128,378.409,332.389Z",
  transform: "translate(-377.592 -264.499)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(199.3 791.079)"
}, /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M523.874,391.854a189.943,189.943,0,0,0,.008-40.488c-2.1-20.36-8.733-43.846-31.335-49.053-9.454-2.178-19.857.04-28.07,4.978-7.941,4.775-11.518,12.653-13.948,21.231-5.418,19.122-6.494,40.463-5.35,60.229a60.374,60.374,0,0,0,.863,7.716c.448,2.368-5.414,1.418-5.809-.672-1.378-7.3-1.227-14.959-1.112-22.347a240.759,240.759,0,0,1,2.439-30.965c1.328-9.123,3.2-18.618,7.472-26.87,3.778-7.292,10.952-12.11,18.5-14.85,16.71-6.07,37.688-1.806,49.017,12.413,12.286,15.419,13.9,37.694,14.132,56.64a191,191,0,0,1-1.011,23.591c-.233,2.078-6.055.757-5.795-1.553Z",
  transform: "translate(-439.05 -298.079)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.388 20.308)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M511.544,389.925a158.164,158.164,0,0,0-.171-31.654c-1.55-15.208-6.691-34.641-25.1-35.409a22.2,22.2,0,0,0-18.414,8.97c-3.984,5.44-4.976,13.479-5.985,19.946-2.076,13.307-3.422,28.355-1.19,41.753.51,3.062-5.431,2.387-5.891-.373-2.547-15.3-.721-32.677,2.119-47.789,1.315-7,3.271-14.645,8.7-19.643,5.8-5.345,13.5-7.634,21.3-7.309,33.447,1.393,32.806,49.393,30.428,73.061-.284,2.83-6.09,1.383-5.795-1.553Z",
  transform: "translate(-453.58 -318.387)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30.314 42.863)"
}, /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M494.24,387.189c.334-5.5.309-11.037.115-16.541-.172-4.875-.492-26.011-8.208-25.762-7.636.247-7.777,15.967-8.171,20.943a138.072,138.072,0,0,0-.242,24.1c.275,2.81-5.612,1.888-5.848-.528-.97-9.9-.3-20.242.754-30.1.864-8.125,3.368-19.358,13.873-18.284,10.789,1.1,12.516,15.523,13.3,23.864a155.05,155.05,0,0,1,.222,23.863c-.146,2.41-5.955,1.079-5.794-1.552Z",
  transform: "translate(-471.418 -340.942)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(143.699 906.438)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 11.501)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M509.435,426.285c19.99-2.739,43.262-1.953,61.041,8.6,9.751,5.79,19.571,18.4,14.4,30.262-6.165,14.136-27.522,15.665-40.472,15.916-18.9.366-42.439-1.591-56.445-16.019-5.973-6.153-8.569-15.445-4.5-23.337,4.967-9.625,15.834-13.872,25.977-15.424,1.4-.214,2.961,1.773,1.014,2.07-13.331,2.039-30.333,11.624-25.155,27.69,2.449,7.6,9.5,12.7,16.373,16.023,11.492,5.547,24.813,6.58,37.372,6.9,13.7.351,40.228-.554,44.041-18.012,1.259-5.763-1.424-11.681-4.759-16.228-6.8-9.268-18.562-13.361-29.369-15.6-12.56-2.606-25.837-2.511-38.5-.775C509.048,428.547,507.483,426.553,509.435,426.285Z",
  transform: "translate(-481.486 -424.94)"
})), /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M482.852,414.631c21.867-3.117,56.088-1,69.588,17s3,40-52.5,35S444.264,420.131,482.852,414.631Z",
  transform: "translate(-427.251 -413.438)"
})), /*#__PURE__*/React.createElement("path", {
  className: "j",
  d: "M387.174,487.4c13.544-.331,27.09.141,39.646-12.506s22.8-28.674,12.554-35.837-39.083,20.66-39.083,20.66,16.616-59.442,2.741-65.766-27.754,42.074-26.432,57.082c0,0-16.4-40.218-32.648-41.483s-10.962,31.617,4.235,49.323S374.264,487.714,387.174,487.4Z",
  transform: "translate(-47.572 493)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(387.139 828.985)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M301.452,335.985c4.456.019,14.224,5.441,25.78,25.507s20.152,44.976,13.041,46.763-71.417,6.239-73.788,0S276.264,368.814,281.3,359,295.526,335.961,301.452,335.985Z",
  transform: "translate(-266.181 -335.985)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(276 606.301)"
}, /*#__PURE__*/React.createElement("path", {
  className: "l",
  d: "M293.78,335.985c3.487.015,11.13,4.257,20.172,19.959s15.769,35.193,10.2,36.591-55.882,4.882-57.738,0,7.652-30.862,11.594-38.539S289.143,335.966,293.78,335.985Z",
  transform: "translate(-266.181 -335.985)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(386.884 789.388)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M292.611,385.158c3.512-.356,7.517-1.462,10.016-4.063,2.918-3.04-.055-7.117-3.082-8.513a13.3,13.3,0,0,0-5.4-1.079c-1.285,0-2.586-2.63-.934-2.631,5.789,0,13.652,3.706,13.051,10.606-.51,5.839-7.841,7.816-12.718,8.31-1.287.131-2.6-2.462-.934-2.63Z",
  transform: "translate(-255.005 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M281.5,365.167c3.976-1.973,8.3-5.865,7.747-10.68-.808-7.037-10.126-6.281-14.9-4.494-1.216.455-2.9-2-1.511-2.524,6.383-2.391,14.324-1.9,17.877,4.644s-2.077,12.785-7.706,15.579c-1.147.571-2.859-1.854-1.51-2.525Z",
  transform: "translate(-221.025 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M316.533,345.023c2.591-2.277,5.48-5.871,4.99-9.524-.658-4.915-9.47-2.821-12.493-1.772-1.055.366-2.8-2.043-1.572-2.47,4.591-1.594,11.9-2.646,15.075,2.076,3.308,4.913-.12,10.514-4.014,13.94-.889.782-2.875-1.467-1.986-2.25Z",
  transform: "translate(-287.785 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M292.695,329.307c4.082-1.261,7.287-5.627,4.1-9.611-2.029-2.534-6.882-.389-9.022,1.01-1.135.743-3.06-1.546-1.986-2.25,3.832-2.505,8.984-3.707,12.48-.059,4.6,4.794,1.739,11.636-4.047,13.423-1.208.373-2.89-2.092-1.523-2.513Z",
  transform: "translate(-242.902 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M265.316,450.87c5.947-2.956,12.417-8.785,11.6-15.988-1.2-10.53-15.138-9.391-22.277-6.712-1.817.683-4.336-3-2.256-3.775,9.549-3.585,21.425-2.858,26.733,6.932s-3.119,19.134-11.54,23.32c-1.716.855-4.274-2.772-2.256-3.777Z",
  transform: "translate(-189.246 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M237.911,360.8c3.512-.357,7.517-1.462,10.016-4.064,2.918-3.04-.055-7.116-3.082-8.512a13.3,13.3,0,0,0-5.4-1.079c-1.285,0-2.587-2.63-.934-2.631,5.789,0,13.652,3.706,13.051,10.605-.51,5.84-7.841,7.817-12.718,8.311-1.287.131-2.6-2.462-.934-2.63Z",
  transform: "translate(-145.605 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M289,464.967c3.324-1.19,6.945-3.225,8.746-6.351,2.1-3.652-1.763-6.894-5.037-7.522a13.289,13.289,0,0,0-5.5.249c-1.248.309-3.144-1.931-1.54-2.329,5.619-1.4,14.143.317,15.217,7.159.908,5.791-5.733,9.472-10.349,11.123-1.217.435-3.117-1.765-1.538-2.329Z",
  transform: "translate(-242.903 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M308.465,426.742c3.324-1.189,6.946-3.224,8.746-6.35,2.1-3.653-1.763-6.895-5.037-7.523a13.307,13.307,0,0,0-5.5.249c-1.248.31-3.143-1.93-1.539-2.329,5.618-1.394,14.142.317,15.217,7.159.908,5.791-5.734,9.472-10.35,11.123-1.217.436-3.117-1.764-1.538-2.329Z",
  transform: "translate(-281.841 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M331.143,374.86c3.324-1.189,6.946-3.224,8.747-6.35,2.1-3.653-1.763-6.9-5.037-7.523a13.311,13.311,0,0,0-5.5.249c-1.247.31-3.143-1.93-1.539-2.329,5.619-1.394,14.143.318,15.217,7.159.908,5.791-5.734,9.472-10.349,11.124-1.218.435-3.117-1.765-1.539-2.33Z",
  transform: "translate(-327.199 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M315.691,312.79c3.325-1.189,6.946-3.225,8.747-6.35,2.1-3.653-1.763-6.895-5.037-7.523a13.3,13.3,0,0,0-5.5.249c-1.247.31-3.143-1.931-1.539-2.329,5.619-1.4,14.143.317,15.217,7.159.908,5.791-5.733,9.472-10.349,11.123-1.217.436-3.117-1.765-1.539-2.329Z",
  transform: "translate(-296.295 -296.388)"
}), /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M254.813,488.112c3.324-1.189,6.945-3.224,8.746-6.35,2.1-3.653-1.763-6.895-5.037-7.523a13.312,13.312,0,0,0-5.5.249c-1.247.31-3.142-1.93-1.539-2.329,5.619-1.394,14.143.318,15.217,7.159.908,5.791-5.733,9.472-10.349,11.123-1.218.436-3.117-1.764-1.538-2.329Z",
  transform: "translate(-174.536 -296.388)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(479.131 795.923)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M221.344,306.043c14.7,5.335,25.6,18.469,28.8,35.2s-3.8,36.055-28.8,44.893-21,12.021-24,33.18-23.193,47.939-64.1,32.048-48.9-37.062-43.4-57.476,17.807-35.235,43.4-41.574,36.608-13.28,41.6-24.06S189.844,294.613,221.344,306.043Z",
  transform: "translate(-88.299 -302.923)"
}), /*#__PURE__*/React.createElement("g", {
  className: "m"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-56.601 -13.943)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(118.445)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(18.846 26.981)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.463 47.37)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M165.648,372.769c1.167-1.247,1.436-3.1,1.854-4.406a3.237,3.237,0,0,0-1.076-3.763c-1.018-.953-2.159-1.684-3.9-1-1.282.5-3.307.818-4.471,2.065s-1.219,3.327-1.635,4.637c-.568,1.779-.395,3.366.619,4.317s2.523.8,4.262.112C162.586,374.227,164.482,374.015,165.648,372.769Z",
  transform: "translate(-156.104 -363.331)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 67.147)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M167.086,392.94c1.167-1.246,2.557-2.605,2.973-3.917.568-1.779-1.009-3.058-2.025-4.009s-2.388-2.412-4.124-1.731c-1.282.5-2.235,2.254-3.4,3.5s-2.8,2.33-3.217,3.641a4.868,4.868,0,0,0,6.037,5.629A12.375,12.375,0,0,0,167.086,392.94Z",
  transform: "translate(-157.13 -383.108)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.526 53.116)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M142.341,377.533a8.947,8.947,0,0,0,1.88-3.88c.567-1.778.689-2.5-.328-3.448a3.117,3.117,0,0,0-3.747-.825,10.357,10.357,0,0,0-3.7,2.636c-1.167,1.246-1.234,2.789-1.651,4.1-.568,1.78-1.259,3.112-.243,4.064a4.553,4.553,0,0,0,4.613.952C140.446,380.629,141.173,378.78,142.341,377.533Z",
  transform: "translate(-134.033 -369.077)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.966 76.356)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M158.355,401.819c1.166-1.247,1.1-3.217,1.522-4.528.566-1.778.445-2.934-.571-3.886a3.642,3.642,0,0,0-4.1-.773,10.844,10.844,0,0,0-3.961,2.533c-1.166,1.246-2.571,2.58-2.99,3.89-.567,1.779,1.034,3.012,2.048,3.965s1.821,1.118,3.56.435C155.145,402.952,157.187,403.065,158.355,401.819Z",
  transform: "translate(-148.14 -392.317)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.179 34.881)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M141.106,359.815a12.124,12.124,0,0,0,2.754-4c.567-1.779-.7-3.109-1.719-4.059s-2.067-1.213-3.8-.532a10.024,10.024,0,0,0-3.95,2.3,10.179,10.179,0,0,0-2.116,4.069c-.564,1.776-1.272,4.027-.255,4.978s3.546.95,5.284.266A12.143,12.143,0,0,0,141.106,359.815Z",
  transform: "translate(-131.502 -350.842)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.49 68.725)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M130.737,395a12.078,12.078,0,0,0,2.651-4.105c.567-1.78.329-4.23-.689-5.183a5.967,5.967,0,0,0-5.35-.686,15.543,15.543,0,0,0-6.768,7.256c-.567,1.781,1.3,2.946,2.321,3.9s1.726,1.27,3.463.588C127.644,396.26,129.57,396.242,130.737,395Z",
  transform: "translate(-120.476 -384.686)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.316 46.195)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M116.621,371.33a11.17,11.17,0,0,0,2.056-4.366,3.506,3.506,0,0,0-1.265-3.9c-1.017-.953-2.048-1.2-3.785-.52a10.062,10.062,0,0,0-4.012,2.228c-1.167,1.245-2.554,2.517-2.971,3.826-.567,1.779-.208,4.152.806,5.105s3.016.147,4.754-.536C113.481,372.662,115.455,372.574,116.621,371.33Z",
  transform: "translate(-106.375 -362.156)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.461 21.848)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M114.7,346.838c1.166-1.244,3.224-1.832,3.641-3.142.568-1.779.557-4.4-.461-5.356s-3.509-.467-5.245.215a11.2,11.2,0,0,0-4.02,2.587c-1.167,1.247-.938,3.179-1.355,4.491-.567,1.777-1.322,3.431-.306,4.381s2.93.89,4.668.207C112.9,349.718,113.532,348.087,114.7,346.838Z",
  transform: "translate(-106.453 -337.808)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.212 44.648)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M96.409,370.5a11.383,11.383,0,0,0,2.119-4.382c.564-1.778.707-4.137-.309-5.09s-3.131-.065-4.867.618c-1.28.5-2.927.913-4.092,2.161s-2.775,2.5-3.19,3.809c-.568,1.78-.159,4.525.858,5.476s3.3-.038,5.039-.721C93.248,371.865,95.242,371.744,96.409,370.5Z",
  transform: "translate(-85.812 -360.609)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(72.687 21.397)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M94.1,345.875c1.166-1.247,2.665-2.147,3.082-3.459.566-1.778.379-3.739-.636-4.69s-2.526.163-4.263.845a8.741,8.741,0,0,0-3.409,2.41c-1.167,1.246-2.569,2-2.987,3.305a3.242,3.242,0,0,0,.972,3.785c1.018.951,1.833.71,3.57.028A8.963,8.963,0,0,0,94.1,345.875Z",
  transform: "translate(-85.65 -337.358)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(64.763 4.211)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M102.02,328.689c1.165-1.247,2.664-2.148,3.081-3.459.567-1.778.38-3.739-.636-4.691s-2.525.164-4.261.846a8.717,8.717,0,0,0-3.409,2.411c-1.169,1.246-2.572,1.993-2.99,3.305a3.242,3.242,0,0,0,.974,3.784c1.016.951,1.832.711,3.569.028A8.97,8.97,0,0,0,102.02,328.689Z",
  transform: "translate(-93.573 -320.172)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(93.934 32.434)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M74,357.567a11.108,11.108,0,0,0,2.055-4.365,3.505,3.505,0,0,0-1.265-3.9c-1.016-.951-2.048-1.2-3.785-.52A10.066,10.066,0,0,0,67,351.01c-1.166,1.244-2.553,2.516-2.971,3.825-.566,1.779-.208,4.152.808,5.105s3.015.147,4.752-.536C70.864,358.9,72.837,358.814,74,357.567Z",
  transform: "translate(-63.758 -348.395)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(99.261 13.652)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M66.9,338.645c1.167-1.246,3.224-1.835,3.643-3.144.567-1.778.556-4.4-.461-5.354s-3.511-.47-5.247.211a11.212,11.212,0,0,0-4.018,2.59c-1.167,1.245-.938,3.178-1.356,4.49-.567,1.777-1.322,3.429-.305,4.38s2.93.891,4.666.208C65.1,341.524,65.731,339.892,66.9,338.645Z",
  transform: "translate(-58.653 -329.613)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(87.894)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M78.266,324.992c1.167-1.245,3.224-1.834,3.642-3.143.567-1.78.557-4.4-.461-5.355s-3.509-.47-5.246.212a11.239,11.239,0,0,0-4.019,2.589c-1.166,1.247-.938,3.18-1.356,4.489-.566,1.779-1.321,3.431-.305,4.382s2.93.891,4.666.208C76.467,327.871,77.1,326.238,78.266,324.992Z",
  transform: "translate(-70.021 -315.961)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.461 25.974)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M184.5,324.391c1.167-1.245,1.438-3.094,1.855-4.406a3.235,3.235,0,0,0-1.08-3.763,3.376,3.376,0,0,0-3.892-1c-1.281.5-3.305.817-4.471,2.063s-1.219,3.329-1.637,4.64c-.566,1.777-.391,3.362.623,4.315s2.522.8,4.26.113C181.434,325.85,183.33,325.636,184.5,324.391Z",
  transform: "translate(-174.951 -314.955)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 45.752)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M185.932,344.561c1.166-1.244,2.558-2.605,2.974-3.914.566-1.779-1.012-3.059-2.027-4.01s-2.388-2.411-4.126-1.73c-1.278.5-2.231,2.252-3.4,3.5s-2.8,2.329-3.215,3.641a4.864,4.864,0,0,0,6.035,5.629A12.355,12.355,0,0,0,185.932,344.561Z",
  transform: "translate(-175.977 -334.732)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(25.525 31.719)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M161.186,329.157a8.928,8.928,0,0,0,1.881-3.882c.569-1.778.688-2.495-.326-3.448a3.121,3.121,0,0,0-3.747-.825,10.314,10.314,0,0,0-3.7,2.637c-1.169,1.246-1.236,2.789-1.654,4.1-.567,1.781-1.256,3.113-.24,4.064a4.544,4.544,0,0,0,4.611.953C159.29,332.254,160.019,330.4,161.186,329.157Z",
  transform: "translate(-152.881 -320.699)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.963 54.961)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M177.2,353.442c1.164-1.247,1.1-3.218,1.523-4.528.564-1.778.444-2.935-.572-3.886a3.642,3.642,0,0,0-4.1-.773,10.79,10.79,0,0,0-3.963,2.535c-1.167,1.246-2.572,2.578-2.992,3.889-.566,1.779,1.034,3.011,2.05,3.963s1.822,1.118,3.558.435C173.995,354.574,176.035,354.689,177.2,353.442Z",
  transform: "translate(-166.987 -343.941)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.177 13.485)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M159.955,311.438a12.113,12.113,0,0,0,2.754-4c.565-1.775-.7-3.106-1.719-4.055s-2.066-1.215-3.8-.533a10.036,10.036,0,0,0-3.95,2.3,10.184,10.184,0,0,0-2.117,4.068c-.567,1.778-1.272,4.029-.253,4.978s3.546.95,5.283.266A12.15,12.15,0,0,0,159.955,311.438Z",
  transform: "translate(-150.35 -302.465)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.488 47.329)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M149.589,346.619a12.074,12.074,0,0,0,2.648-4.1c.567-1.78.329-4.23-.689-5.183a5.968,5.968,0,0,0-5.349-.688,15.564,15.564,0,0,0-6.769,7.256c-.565,1.781,1.306,2.948,2.321,3.9s1.726,1.271,3.464.589C146.494,347.883,148.42,347.865,149.589,346.619Z",
  transform: "translate(-139.325 -336.309)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.315 24.798)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M135.469,322.952a11.126,11.126,0,0,0,2.055-4.366,3.507,3.507,0,0,0-1.265-3.9c-1.016-.952-2.047-1.2-3.785-.519a10.04,10.04,0,0,0-4.011,2.228c-1.168,1.246-2.555,2.516-2.971,3.827-.567,1.778-.209,4.151.806,5.1s3.014.149,4.751-.535C132.328,324.286,134.3,324.2,135.469,322.952Z",
  transform: "translate(-125.223 -313.778)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.459 0.452)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M133.545,298.462c1.169-1.246,3.226-1.834,3.645-3.144.566-1.778.555-4.4-.462-5.354s-3.51-.469-5.245.213a11.219,11.219,0,0,0-4.021,2.589c-1.165,1.246-.937,3.179-1.354,4.49-.568,1.776-1.323,3.429-.307,4.38s2.93.891,4.667.209C131.748,301.34,132.379,299.709,133.545,298.462Z",
  transform: "translate(-125.301 -289.432)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.21 23.253)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M115.257,322.119a11.349,11.349,0,0,0,2.117-4.382c.566-1.776.708-4.135-.307-5.088s-3.133-.066-4.866.617c-1.283.5-2.929.913-4.1,2.16s-2.774,2.5-3.19,3.81c-.566,1.779-.156,4.524.859,5.474s3.3-.037,5.041-.719C112.1,323.487,114.09,323.366,115.257,322.119Z",
  transform: "translate(-104.66 -312.233)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(72.685)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M112.945,297.5c1.164-1.246,2.664-2.146,3.08-3.457.566-1.779.379-3.74-.636-4.692s-2.525.164-4.262.846a8.744,8.744,0,0,0-3.41,2.41c-1.167,1.247-2.569,2-2.987,3.3a3.239,3.239,0,0,0,.973,3.784c1.017.952,1.832.712,3.569.03A8.959,8.959,0,0,0,112.945,297.5Z",
  transform: "translate(-104.498 -288.98)"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 41.813)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.88 18.963)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 65.202)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M277.714,423.846c.869-1.471.731-3.333.855-4.7A3.237,3.237,0,0,0,276.7,415.7c-1.2-.71-2.472-1.177-4.019-.135-1.143.769-3.052,1.515-3.919,2.985s-.468,3.513-.591,4.881c-.169,1.86.344,3.372,1.54,4.081s2.634.23,4.185-.814C275.04,425.932,276.845,425.315,277.714,423.846Z",
  transform: "translate(-268.143 -414.959)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.817 85.064)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M274.709,443.982c.869-1.468,1.932-3.1,2.053-4.467.17-1.861-1.647-2.768-2.845-3.476s-2.853-1.838-4.4-.8c-1.142.77-1.693,2.685-2.561,4.154s-2.228,2.881-2.352,4.251a4.867,4.867,0,0,0,7.114,4.187A12.371,12.371,0,0,0,274.709,443.982Z",
  transform: "translate(-264.589 -434.821)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.042 65.862)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M253.481,423.77a8.973,8.973,0,0,0,.995-4.2c.168-1.859.131-2.587-1.067-3.3a3.119,3.119,0,0,0-3.837.007,10.336,10.336,0,0,0-3.04,3.374c-.87,1.47-.6,2.99-.724,4.362-.169,1.859-.555,3.309.643,4.019a4.554,4.554,0,0,0,4.71-.07C252.3,427.2,252.61,425.239,253.481,423.77Z",
  transform: "translate(-245.612 -415.619)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.376 91.668)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M264.671,450.435c.868-1.469.381-3.379.505-4.75.168-1.859-.2-2.96-1.4-3.669a3.641,3.641,0,0,0-4.166.131,10.856,10.856,0,0,0-3.318,3.331c-.869,1.47-1.952,3.077-2.077,4.446-.168,1.86,1.662,2.718,2.858,3.427s2.021.7,3.57-.346C261.783,452.237,263.8,451.9,264.671,450.435Z",
  transform: "translate(-254.205 -441.425)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.743 47.692)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M256.012,406.049a12.132,12.132,0,0,0,1.823-4.5c.168-1.858-1.36-2.882-2.558-3.59s-2.281-.736-3.828.3a10.04,10.04,0,0,0-3.359,3.1,10.2,10.2,0,0,0-1.184,4.431c-.166,1.856-.37,4.208.83,4.916s3.668.158,5.216-.886A12.117,12.117,0,0,0,256.012,406.049Z",
  transform: "translate(-246.779 -397.449)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.791 78.336)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M239.078,438.02a12.086,12.086,0,0,0,1.7-4.582c.168-1.861-.6-4.2-1.795-4.912a5.968,5.968,0,0,0-5.372.49,15.528,15.528,0,0,0-5.035,8.55c-.168,1.861,1.912,2.592,3.109,3.3s1.961.866,3.509-.176C236.332,439.923,238.208,439.488,239.078,438.02Z",
  transform: "translate(-228.565 -428.093)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.284 53.202)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M230.229,411.707a11.155,11.155,0,0,0,1.06-4.708,3.507,3.507,0,0,0-2.079-3.535c-1.2-.709-2.26-.73-3.808.313a10.074,10.074,0,0,0-3.433,3.043c-.87,1.469-1.949,3.012-2.073,4.379-.168,1.861.7,4.1,1.893,4.81s2.976-.51,4.525-1.553C227.452,413.688,229.36,413.174,230.229,411.707Z",
  transform: "translate(-219.875 -402.959)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.804 29.22)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M232.884,388.2c.868-1.468,2.75-2.487,2.874-3.856.169-1.86-.41-4.42-1.611-5.129s-3.527.3-5.073,1.346a11.189,11.189,0,0,0-3.365,3.4c-.869,1.47-.227,3.308-.35,4.678-.169,1.858-.548,3.636.651,4.344s3.052.234,4.6-.81C231.749,391.4,232.014,389.67,232.884,388.2Z",
  transform: "translate(-225.166 -378.977)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(66.485 46.912)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M210.949,406.508a11.393,11.393,0,0,0,1.119-4.736c.166-1.859-.206-4.192-1.405-4.9s-3.07.614-4.617,1.657c-1.142.767-2.66,1.526-3.527,3s-2.167,3.043-2.289,4.411c-.169,1.86.825,4.451,2.024,5.159s3.216-.752,4.763-1.8C208.159,408.528,210.079,407.978,210.949,406.508Z",
  transform: "translate(-200.212 -396.669)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.843 24.184)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M213.46,382.617c.868-1.47,2.137-2.673,2.26-4.045.167-1.858-.44-3.732-1.637-4.44s-2.43.706-3.978,1.749a8.715,8.715,0,0,0-2.806,3.091c-.87,1.468-2.077,2.5-2.2,3.873a3.243,3.243,0,0,0,1.769,3.485c1.2.707,1.943.3,3.491-.747A8.947,8.947,0,0,0,213.46,382.617Z",
  transform: "translate(-205.075 -373.941)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.384 9.121)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M224.92,367.555c.867-1.469,2.135-2.674,2.259-4.043.168-1.86-.44-3.733-1.638-4.443s-2.429.707-3.976,1.749a8.709,8.709,0,0,0-2.806,3.092c-.871,1.47-2.08,2.5-2.2,3.874a3.241,3.241,0,0,0,1.77,3.484c1.2.709,1.943.3,3.491-.746A8.979,8.979,0,0,0,224.92,367.555Z",
  transform: "translate(-216.532 -358.878)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(85.909 30.536)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M191.6,389.04a11.121,11.121,0,0,0,1.06-4.707,3.507,3.507,0,0,0-2.08-3.535c-1.2-.708-2.259-.73-3.807.312a10.072,10.072,0,0,0-3.434,3.045c-.869,1.468-1.947,3.01-2.072,4.378-.168,1.861.7,4.1,1.894,4.809s2.975-.509,4.523-1.552C188.827,391.022,190.734,390.509,191.6,389.04Z",
  transform: "translate(-181.25 -380.293)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(87.694 10.866)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M187.993,369.846c.87-1.469,2.75-2.49,2.875-3.859.168-1.858-.41-4.42-1.61-5.127s-3.528.3-5.076,1.343a11.23,11.23,0,0,0-3.362,3.4c-.87,1.467-.227,3.3-.351,4.675-.169,1.859-.548,3.635.651,4.344s3.054.234,4.6-.808C186.86,373.047,187.123,371.316,187.993,369.846Z",
  transform: "translate(-180.276 -360.623)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(73.639)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M202.048,358.979c.869-1.467,2.75-2.488,2.874-3.857.169-1.86-.41-4.421-1.61-5.128s-3.527.3-5.075,1.343a11.262,11.262,0,0,0-3.364,3.4c-.867,1.47-.226,3.308-.35,4.677-.168,1.859-.547,3.635.651,4.344s3.053.234,4.6-.808C200.915,362.18,201.177,360.449,202.048,358.979Z",
  transform: "translate(-194.331 -349.757)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 41.02)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M306.591,380.7c.87-1.468.734-3.332.858-4.7a3.236,3.236,0,0,0-1.87-3.44,3.379,3.379,0,0,0-4.017-.134c-1.142.768-3.049,1.514-3.918,2.983s-.469,3.514-.592,4.884c-.168,1.858.345,3.367,1.542,4.078s2.635.231,4.183-.812C303.919,382.786,305.723,382.166,306.591,380.7Z",
  transform: "translate(-297.021 -371.814)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.819 60.882)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M303.585,400.834c.868-1.467,1.932-3.1,2.055-4.466.168-1.858-1.65-2.766-2.848-3.475s-2.852-1.837-4.4-.8c-1.139.767-1.69,2.682-2.559,4.152s-2.229,2.88-2.351,4.251a4.865,4.865,0,0,0,7.112,4.188A12.378,12.378,0,0,0,303.585,400.834Z",
  transform: "translate(-293.466 -391.676)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.042 41.679)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M282.358,380.625a8.941,8.941,0,0,0,1-4.2c.169-1.859.13-2.584-1.066-3.3a3.121,3.121,0,0,0-3.837.006,10.3,10.3,0,0,0-3.04,3.375c-.872,1.469-.6,2.991-.726,4.36-.169,1.861-.553,3.311.645,4.02a4.545,4.545,0,0,0,4.708-.069C281.178,384.059,281.489,382.094,282.358,380.625Z",
  transform: "translate(-274.491 -372.473)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.375 67.485)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M293.551,407.29c.866-1.47.381-3.382.506-4.751.165-1.858-.2-2.961-1.4-3.67a3.645,3.645,0,0,0-4.166.132,10.772,10.772,0,0,0-3.319,3.334c-.869,1.469-1.953,3.074-2.079,4.444-.167,1.86,1.662,2.715,2.859,3.425s2.022.7,3.569-.346C290.663,409.09,292.68,408.76,293.551,407.29Z",
  transform: "translate(-283.083 -398.279)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.742 23.51)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M284.893,362.9a12.09,12.09,0,0,0,1.822-4.5c.167-1.855-1.358-2.88-2.557-3.586s-2.28-.739-3.827.3a10.054,10.054,0,0,0-3.359,3.1,10.2,10.2,0,0,0-1.186,4.431c-.167,1.858-.368,4.208.832,4.915s3.667.159,5.215-.885A12.159,12.159,0,0,0,284.893,362.9Z",
  transform: "translate(-275.659 -354.303)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.791 54.154)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M267.96,394.873a12.053,12.053,0,0,0,1.7-4.581c.169-1.859-.594-4.2-1.8-4.91a5.967,5.967,0,0,0-5.371.486,15.569,15.569,0,0,0-5.036,8.551c-.167,1.86,1.913,2.6,3.11,3.3s1.959.867,3.508-.176C265.212,396.777,267.089,396.343,267.96,394.873Z",
  transform: "translate(-257.445 -384.948)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.285 29.019)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M259.106,368.56a11.134,11.134,0,0,0,1.061-4.707,3.507,3.507,0,0,0-2.081-3.535c-1.2-.709-2.258-.731-3.807.313a10.027,10.027,0,0,0-3.433,3.044c-.871,1.47-1.949,3.01-2.072,4.38-.168,1.858.7,4.1,1.893,4.807s2.974-.508,4.522-1.552C256.329,370.543,258.236,370.029,259.106,368.56Z",
  transform: "translate(-248.753 -359.813)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.805 5.038)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M261.76,345.054c.871-1.47,2.752-2.489,2.877-3.859.167-1.858-.412-4.419-1.611-5.127s-3.528.3-5.075,1.344a11.228,11.228,0,0,0-3.364,3.4c-.867,1.469-.226,3.307-.35,4.677-.169,1.858-.547,3.635.65,4.342s3.053.236,4.6-.807C260.629,348.253,260.891,346.523,261.76,345.054Z",
  transform: "translate(-254.045 -335.831)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(66.485 22.731)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M239.828,363.361a11.336,11.336,0,0,0,1.119-4.736c.168-1.856-.205-4.191-1.4-4.9s-3.073.613-4.617,1.655c-1.143.767-2.662,1.526-3.53,3s-2.167,3.042-2.289,4.411c-.167,1.859.827,4.449,2.024,5.157s3.216-.751,4.766-1.793C237.038,365.382,238.96,364.831,239.828,363.361Z",
  transform: "translate(-229.091 -353.524)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.843)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M242.341,339.47c.866-1.469,2.136-2.672,2.258-4.042.167-1.86-.44-3.734-1.638-4.444s-2.429.707-3.977,1.75a8.748,8.748,0,0,0-2.807,3.092c-.869,1.469-2.076,2.5-2.2,3.873a3.238,3.238,0,0,0,1.769,3.484c1.2.708,1.943.3,3.491-.744A8.979,8.979,0,0,0,242.341,339.47Z",
  transform: "translate(-233.954 -330.794)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(64.985 115.19)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.88 18.963)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 65.202)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M212.729,497.223c.869-1.471.732-3.333.855-4.7a3.236,3.236,0,0,0-1.865-3.441c-1.2-.71-2.472-1.177-4.019-.135-1.143.769-3.051,1.515-3.918,2.985s-.469,3.512-.592,4.881c-.169,1.86.344,3.372,1.54,4.081s2.635.23,4.185-.814C210.056,499.309,211.86,498.691,212.729,497.223Z",
  transform: "translate(-203.158 -488.336)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.817 85.064)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M209.723,517.359c.869-1.468,1.933-3.1,2.054-4.467.169-1.861-1.648-2.768-2.846-3.476s-2.853-1.838-4.4-.8c-1.142.77-1.694,2.685-2.561,4.153s-2.229,2.882-2.353,4.251a4.867,4.867,0,0,0,7.114,4.188A12.356,12.356,0,0,0,209.723,517.359Z",
  transform: "translate(-199.603 -508.198)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.042 65.862)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M188.5,497.147a8.973,8.973,0,0,0,1-4.2c.168-1.859.131-2.587-1.067-3.3a3.119,3.119,0,0,0-3.837.007,10.347,10.347,0,0,0-3.04,3.374c-.87,1.47-.6,2.99-.724,4.361-.169,1.86-.555,3.31.643,4.02a4.554,4.554,0,0,0,4.71-.07C187.317,500.579,187.626,498.616,188.5,497.147Z",
  transform: "translate(-180.627 -488.996)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.376 91.668)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M199.685,523.813c.868-1.47.381-3.38.506-4.75.167-1.86-.2-2.961-1.4-3.67a3.641,3.641,0,0,0-4.166.131,10.858,10.858,0,0,0-3.319,3.331c-.869,1.47-1.952,3.077-2.076,4.446-.169,1.86,1.661,2.718,2.857,3.427s2.021.7,3.57-.346C196.8,525.614,198.815,525.281,199.685,523.813Z",
  transform: "translate(-189.219 -514.802)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.743 47.692)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M191.028,479.426a12.129,12.129,0,0,0,1.822-4.5c.168-1.859-1.36-2.882-2.557-3.59s-2.281-.736-3.828.3a10.03,10.03,0,0,0-3.359,3.1,10.182,10.182,0,0,0-1.184,4.431c-.167,1.856-.37,4.208.829,4.916s3.668.158,5.216-.886A12.133,12.133,0,0,0,191.028,479.426Z",
  transform: "translate(-181.794 -470.826)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.791 78.336)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M174.093,511.4a12.086,12.086,0,0,0,1.7-4.582c.168-1.861-.6-4.2-1.795-4.912a5.968,5.968,0,0,0-5.372.49,15.543,15.543,0,0,0-5.035,8.55c-.168,1.861,1.912,2.592,3.11,3.3s1.961.866,3.508-.176C171.347,513.3,173.224,512.865,174.093,511.4Z",
  transform: "translate(-163.58 -501.47)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.284 53.202)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M165.243,485.084a11.157,11.157,0,0,0,1.061-4.708,3.509,3.509,0,0,0-2.079-3.535c-1.2-.709-2.261-.73-3.809.313a10.073,10.073,0,0,0-3.433,3.043c-.87,1.469-1.948,3.012-2.073,4.379-.168,1.86.7,4.1,1.893,4.81s2.976-.51,4.525-1.553C162.466,487.065,164.374,486.551,165.243,485.084Z",
  transform: "translate(-154.889 -476.336)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.804 29.22)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M167.9,461.575c.869-1.468,2.751-2.487,2.874-3.856.169-1.86-.41-4.42-1.61-5.129s-3.528.3-5.074,1.345a11.2,11.2,0,0,0-3.365,3.4c-.868,1.47-.226,3.308-.35,4.678-.169,1.858-.547,3.636.651,4.343s3.053.235,4.6-.809C166.765,464.776,167.029,463.047,167.9,461.575Z",
  transform: "translate(-160.181 -452.354)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(66.485 46.912)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M145.964,479.885a11.378,11.378,0,0,0,1.119-4.737c.166-1.858-.2-4.191-1.4-4.9s-3.071.614-4.618,1.657c-1.141.767-2.66,1.526-3.527,3s-2.167,3.043-2.289,4.411c-.169,1.86.826,4.451,2.024,5.159s3.217-.752,4.763-1.795C143.174,481.9,145.1,481.355,145.964,479.885Z",
  transform: "translate(-135.227 -470.046)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.844 24.184)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M148.474,455.994c.868-1.47,2.137-2.673,2.26-4.045.168-1.858-.44-3.732-1.636-4.44s-2.431.706-3.979,1.749a8.724,8.724,0,0,0-2.806,3.091c-.869,1.468-2.076,2.5-2.2,3.873a3.242,3.242,0,0,0,1.769,3.485c1.2.707,1.943.3,3.49-.747A8.947,8.947,0,0,0,148.474,455.994Z",
  transform: "translate(-140.089 -447.318)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(51.384 9.121)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M159.935,440.932c.867-1.469,2.136-2.674,2.259-4.043.168-1.86-.44-3.733-1.637-4.443s-2.43.707-3.977,1.749a8.718,8.718,0,0,0-2.806,3.092c-.871,1.47-2.079,2.5-2.2,3.874a3.241,3.241,0,0,0,1.771,3.484c1.2.708,1.942.3,3.491-.746A8.977,8.977,0,0,0,159.935,440.932Z",
  transform: "translate(-151.547 -432.255)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(85.909 30.536)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M126.618,462.417a11.138,11.138,0,0,0,1.061-4.707,3.508,3.508,0,0,0-2.08-3.535c-1.2-.708-2.26-.73-3.807.312a10.064,10.064,0,0,0-3.435,3.045c-.869,1.468-1.947,3.01-2.072,4.378-.167,1.861.7,4.1,1.894,4.809s2.975-.509,4.524-1.552C123.842,464.4,125.749,463.886,126.618,462.417Z",
  transform: "translate(-116.264 -453.67)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(87.694 10.866)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M123.007,443.223c.87-1.469,2.751-2.49,2.876-3.859.168-1.858-.411-4.42-1.61-5.127s-3.529.3-5.076,1.343a11.229,11.229,0,0,0-3.363,3.4c-.869,1.468-.227,3.306-.35,4.676-.169,1.859-.549,3.635.65,4.344s3.054.234,4.6-.809C121.875,446.424,122.138,444.693,123.007,443.223Z",
  transform: "translate(-115.29 -434)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(73.64)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M137.063,432.356c.869-1.467,2.75-2.488,2.874-3.857.169-1.86-.41-4.421-1.609-5.128s-3.528.3-5.076,1.343a11.248,11.248,0,0,0-3.363,3.4c-.868,1.47-.227,3.308-.351,4.677-.167,1.858-.546,3.635.651,4.344s3.053.234,4.6-.808C135.93,435.557,136.193,433.826,137.063,432.356Z",
  transform: "translate(-129.346 -423.134)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 41.02)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M241.606,454.075c.87-1.468.734-3.332.858-4.7a3.236,3.236,0,0,0-1.87-3.44,3.378,3.378,0,0,0-4.016-.134c-1.142.768-3.05,1.515-3.919,2.983s-.469,3.514-.592,4.884c-.168,1.858.346,3.367,1.542,4.078s2.635.231,4.183-.812C238.935,456.163,240.739,455.543,241.606,454.075Z",
  transform: "translate(-232.036 -445.191)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.82 60.882)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M238.6,474.211c.868-1.467,1.932-3.1,2.054-4.466.168-1.858-1.65-2.767-2.847-3.475s-2.853-1.837-4.4-.795c-1.138.767-1.69,2.682-2.559,4.152s-2.229,2.88-2.35,4.251a4.863,4.863,0,0,0,7.111,4.187A12.349,12.349,0,0,0,238.6,474.211Z",
  transform: "translate(-228.481 -465.053)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(24.042 41.679)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M217.373,454a8.942,8.942,0,0,0,1-4.2c.169-1.859.131-2.584-1.066-3.295a3.121,3.121,0,0,0-3.837.006,10.294,10.294,0,0,0-3.039,3.375c-.873,1.469-.6,2.991-.727,4.36-.169,1.861-.553,3.31.645,4.02a4.548,4.548,0,0,0,4.708-.069C216.194,457.435,216.5,455.471,217.373,454Z",
  transform: "translate(-209.506 -445.85)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.375 67.485)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M228.566,480.667c.867-1.47.382-3.382.506-4.751.166-1.858-.2-2.961-1.4-3.67a3.645,3.645,0,0,0-4.166.132,10.794,10.794,0,0,0-3.319,3.334c-.869,1.469-1.953,3.074-2.079,4.444-.167,1.86,1.663,2.715,2.86,3.425s2.021.7,3.568-.346C225.678,482.467,227.7,482.137,228.566,480.667Z",
  transform: "translate(-218.097 -471.656)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.743 23.509)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M219.909,436.279a12.094,12.094,0,0,0,1.821-4.5c.167-1.855-1.358-2.88-2.557-3.586s-2.28-.739-3.827.3a10.054,10.054,0,0,0-3.359,3.1,10.211,10.211,0,0,0-1.185,4.431c-.168,1.858-.369,4.208.831,4.914s3.668.16,5.215-.884A12.147,12.147,0,0,0,219.909,436.279Z",
  transform: "translate(-210.674 -427.68)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.791 54.154)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M202.974,468.25a12.073,12.073,0,0,0,1.7-4.581c.168-1.859-.6-4.2-1.795-4.91a5.967,5.967,0,0,0-5.371.486,15.563,15.563,0,0,0-5.037,8.551c-.167,1.86,1.913,2.6,3.11,3.3s1.96.867,3.509-.176C200.226,470.154,202.1,469.72,202.974,468.25Z",
  transform: "translate(-192.459 -458.325)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.286 29.019)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M194.12,441.936a11.128,11.128,0,0,0,1.061-4.707,3.506,3.506,0,0,0-2.08-3.534c-1.2-.709-2.259-.731-3.808.313a10.035,10.035,0,0,0-3.433,3.044c-.87,1.47-1.949,3.009-2.071,4.38-.169,1.858.695,4.1,1.892,4.807s2.975-.508,4.522-1.551C191.343,443.92,193.25,443.406,194.12,441.936Z",
  transform: "translate(-183.768 -433.19)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.805 5.038)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M196.775,418.431c.871-1.47,2.752-2.49,2.877-3.859.167-1.858-.411-4.419-1.611-5.127s-3.528.3-5.074,1.344a11.212,11.212,0,0,0-3.365,3.4c-.867,1.468-.226,3.306-.349,4.676-.17,1.858-.548,3.635.649,4.342s3.053.236,4.6-.807C195.644,421.63,195.907,419.9,196.775,418.431Z",
  transform: "translate(-189.06 -409.208)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(66.485 22.731)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M174.844,436.738A11.35,11.35,0,0,0,175.962,432c.168-1.856-.205-4.192-1.4-4.9s-3.073.613-4.617,1.655c-1.143.767-2.662,1.526-3.53,3s-2.166,3.042-2.289,4.411c-.167,1.858.828,4.449,2.024,5.157s3.217-.751,4.766-1.793C172.054,438.759,173.975,438.208,174.844,436.738Z",
  transform: "translate(-164.106 -426.901)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.843)"
}, /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M177.356,412.847c.867-1.469,2.136-2.672,2.258-4.042.167-1.86-.44-3.734-1.637-4.444s-2.43.707-3.978,1.75a8.737,8.737,0,0,0-2.806,3.092c-.87,1.469-2.077,2.5-2.2,3.873a3.239,3.239,0,0,0,1.769,3.484c1.2.708,1.944.3,3.492-.745A8.964,8.964,0,0,0,177.356,412.847Z",
  transform: "translate(-168.969 -404.171)"
})))))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.384 30.793)"
}, /*#__PURE__*/React.createElement("path", {
  className: "g",
  d: "M194.241,337.688c19.623,8.185,31.055,30.4,27.646,51.224-1.654,10.109-7.723,18.7-15.888,24.653S186.786,420.71,179.32,427.7c-5.017,4.7-4.617,13.217-5.253,19.477-.883,8.69-2.848,16.757-7.4,24.305-10.252,17.01-29.168,20.668-47.3,15.681-19.315-5.312-42.153-18.338-49.442-38.129C63.856,432.552,71,412.107,81.94,399.362c7.125-8.3,17.178-13.193,27.539-16.108,10.921-3.073,22.5-6.5,31.063-14.321,5.443-4.968,7.3-12.009,10.655-18.312,3.485-6.555,8.476-12.332,15.484-15.153,8.63-3.475,18.55-1.225,26.892,1.945,3.864,1.469.192,2.116-2,1.285-10.5-3.991-20.639-3.191-28.654,5.02-4.954,5.075-7.6,11.8-10.411,18.167-8.934,20.241-35.594,20.072-52.46,29.279C82.987,400.48,72.417,421.686,73.7,440.951c1.573,23.607,27.165,39.235,47.617,44.86,18.67,5.135,35.347-5.173,42.806-22.159,3.123-7.113,3.838-14.718,4.574-22.363.544-5.654,1.017-11.293,5.159-15.553,5.977-6.146,15.73-7.809,23.021-11.816a38.419,38.419,0,0,0,18.447-23.149c5.728-19.818-5.327-44.385-24.416-52.347C187.389,336.955,192.888,337.123,194.241,337.688Z",
  transform: "translate(-67.703 -333.717)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(643.818 822.461)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(61.789)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M22.5,330.566c2.035,4.386.789,4.436,1.364,9.645a66.469,66.469,0,0,1,.5,9.674c-.193,4.495-1.367,7.409-4.068,7.289-2.122-.1-3.155-2.42-3.8-6.247a39.92,39.92,0,0,1-.853-8.364,37.8,37.8,0,0,1,1.325-8.33C18.1,330.228,20.156,327.981,22.5,330.566Z",
  transform: "translate(-15.621 -329.461)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.158 14.276)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M47.625,344.847c2.034,4.385-.019,4.623.556,9.832a66.7,66.7,0,0,1,.825,9.606c-.193,4.495-1.166,7.462-3.867,7.341-2.122-.1-3.659-2.377-4.3-6.2a41.058,41.058,0,0,1-.79-8.47,39.46,39.46,0,0,1,1.235-8.46C42.41,344.487,45.283,342.262,47.625,344.847Z",
  transform: "translate(-40.024 -343.737)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(57.573 47.246)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M26.233,378c1.971,3.981-.409,4.11.25,9.108.358,2.721,1.911,5.69,2.075,8.728a49.269,49.269,0,0,1-.46,8.94c-.529,4-2.167,7.265-4.85,7.145-2.2-.1-4.195-3-5.079-6.632a41.533,41.533,0,0,1-.931-8.308,59.154,59.154,0,0,1,.654-8.289,32.4,32.4,0,0,1,2.159-7.962C21.443,377.148,23.779,375.288,26.233,378Z",
  transform: "translate(-17.23 -376.707)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34.268 74.421)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M50.574,405c2.034,4.387.54,4.444,1.116,9.653a64.666,64.666,0,0,1,.088,9.61c-.194,4.5-.685,8.116-3.386,7.995-2.122-.1-2.965-3.121-3.609-6.948-.427-2.533-1.538-5.447-1.409-8.356a37.4,37.4,0,0,1,1.588-8.35C46.091,404.6,48.232,402.415,50.574,405Z",
  transform: "translate(-43.363 -403.882)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(62.257 102.736)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M21.57,433.3c2.034,4.385.459,4.365,1.034,9.574.348,3.158,1.44,6.6,1.31,9.612-.194,4.495-1.581,8.136-4.281,8.016-2.123-.1-3.1-3.158-3.743-6.985a40.723,40.723,0,0,1-.37-8.338,36.624,36.624,0,0,1,1.356-8.2C18.006,432.974,19.228,430.715,21.57,433.3Z",
  transform: "translate(-15.462 -432.197)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 107.024)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M83.271,437.895c1.971,3.982.544,3.8,1.2,8.8.358,2.721,1.471,5.748,1.635,8.786a50.211,50.211,0,0,1-.312,8.958c-.529,4.005-2.284,6.572-4.967,6.452-2.205-.1-3.045-2.614-3.929-6.245-.578-2.374-1.822-5.059-1.9-8.026a58.987,58.987,0,0,1,.447-8.284,35.023,35.023,0,0,1,1.734-8.125C78.571,436.622,80.817,435.18,83.271,437.895Z",
  transform: "translate(-74.984 -436.485)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(27.578 133.611)"
}, /*#__PURE__*/React.createElement("path", {
  className: "i",
  d: "M56.5,464.208c2.034,4.386.761,4.262,1.336,9.471a66.353,66.353,0,0,1,.745,9.6c-.194,4.495-1.1,7.717-3.8,7.6-2.122-.1-3.973-2.575-4.617-6.4-.427-2.533.4-5.571.529-8.48a38.026,38.026,0,0,1,1.084-8.267C52.91,463.725,54.159,461.623,56.5,464.208Z",
  transform: "translate(-50.047 -463.072)"
})))));

function SvgPatternInscriptionConnexion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 251,
    viewBox: "0 0 375 251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternInscriptionConnexion);
export default __webpack_public_path__ + "static/media/pattern-inscription-connexion.bd37cd9eb103b23cf95b728ec2bf3735.svg";
export { ForwardRef as ReactComponent };